// eslint-disable-next-line
import { purchaseOrderRequestQueryFilter } from 'utils/proptypes';
import base from './baseApi';
import { omitBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';
import axios from 'axios';

const { urls, methods, execute } = base();
const sanitizeQueryFilter = (queryFilter: purchaseOrderRequestQueryFilter) => {
  return omitBy(queryFilter, (value: any) => {
    if (value === '' || value === null || value === undefined) return true;
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized === '' || normalized === 'null' || normalized === 'undefined';
    }
    return false;
  });
};

const getPurchaseOrdersByFilter = (queryFilter: purchaseOrderRequestQueryFilter) => {
  const method = methods.GET;
  const initParams: any = sanitizeQueryFilter(queryFilter);
  const params = createSearchParams(initParams);

  const url = `${urls.purchaseOrder.purchaseOrder}/?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getPurchaseOrders = () => {
  const method = methods.GET;
  const url = `${urls.purchaseOrder.purchaseOrder}?limit=10`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getPurchaseOrderById = (id: string) => {
  const method = methods.GET;
  const url = `${urls.purchaseOrder.purchaseOrder}/${id}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const createPurchaseOrder = (payload: any) => {
  const method = methods.POST;
  const url = `${urls.purchaseOrder.purchaseOrder}`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const updatePurchaseOrderById = (id: any,payload: any) => {
  const method = methods.PUT;
  const url = `${urls.purchaseOrder.purchaseOrder}/${id}`;
  const response = execute(method, url, { authorization: true }, payload);
  return response;
};

const deletePurchaseOrderById = (id: string) => {
    const method = methods.DELETE;
    const url = `${urls.purchaseOrder.purchaseOrder}/${id}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };

const exportPurchaseOrderFormOrg = (orgId: string, queryFilter: purchaseOrderRequestQueryFilter) => {
    const method = methods.GET;
    const initParams: any = sanitizeQueryFilter(queryFilter);
    const params = createSearchParams(initParams);
    const url = `${urls.purchaseOrder.purchaseOrder}/${orgId}/export-purchase-order/?${params.toString()}`;
    const response = execute(method, url, { authorization: true, responseTye: 'blob' });
  
    return response;
  };

const validatePurchaseOrderByN2G = async (payload: any) => {
    const url = `${urls.purchaseOrder.validateOrderN2G}`;
    let res: any;
    axios.post(url, payload, { headers: { 'Access-Control-Allow-Origin' : url, 'Accept': '*/*'}})
    .then(response => {
      res = response
    })
    .catch(error => {
      res = error.response;
    });
  
    return res;
  };

const createPurchaseOrderByN2G = async (payload: any) => {
    const url = `${urls.purchaseOrder.creationOrderN2G}`;
    let res: any;
    axios.post(url, payload, { headers: { 'Access-Control-Allow-Origin' : url, 'Accept': '*/*'}})
    .then(response => {
      res = response
    })
    .catch(error => {
      console.error("error: ", error.response);
    });
  
    return res;
  };

const receivingPurchaseOrderByN2G = async (orderId: number) => {
    const url = `${urls.purchaseOrder.receivingOrderN2G}?orderId=${orderId}`;
    let res: any;
    axios.post(url, { headers: { 'Access-Control-Allow-Origin' : url, 'Accept': '*/*'}})
    .then(response => {
      res = response
    })
    .catch(error => {
      console.error(error.response);
    });
  
    return res;
  };

const createPurchaseOrderByMuscleFoods = async (payload: any) => {
    const method = methods.POST;
    const url = `${urls.purchaseOrder.muscleFoodsCreateOrder}`;
    return execute(method, url, { authorization: true }, payload);
};

const generatePurchaseOrderSuggestions = (locationId: string, organizationVendorId: string, categoryIds?: string[]) => {
    const method = methods.GET;
    // Timestamp busts the ETag/304 cache so Axios always gets a fresh 200 response
    const params = new URLSearchParams({ locationId, organizationVendorId, _t: Date.now().toString() });
    if (categoryIds && categoryIds.length > 0) {
        params.set('categoryIds', categoryIds.join(','));
    }
    const url = `${urls.purchaseOrder.purchaseOrder}/generate-suggestions?${params.toString()}`;
    return execute(method, url, { authorization: true });
};

const reassignPurchaseOrderLocation = (purchaseOrderId: string, locationId: string) => {
    const method = methods.PATCH;
    const url = `${urls.purchaseOrder.purchaseOrder}/${purchaseOrderId}/location`;
    return execute(method, url, { authorization: true }, { locationId });
};

const validateDotfitInventory = (locationId: string, organizationVendorId: string, items: { itemId: string; quantity: number }[]) => {
    const method = methods.POST;
    const url = `${urls.purchaseOrder.purchaseOrder}/dotfit/validate-inventory`;
    return execute(method, url, { authorization: true }, { locationId, organizationVendorId, items });
};

export {
    getPurchaseOrdersByFilter,
    getPurchaseOrders,
    getPurchaseOrderById,
    createPurchaseOrder,
    updatePurchaseOrderById,
    deletePurchaseOrderById,
    exportPurchaseOrderFormOrg,
    validatePurchaseOrderByN2G,
    createPurchaseOrderByN2G,
    receivingPurchaseOrderByN2G,
    createPurchaseOrderByMuscleFoods,
    generatePurchaseOrderSuggestions,
    reassignPurchaseOrderLocation,
    validateDotfitInventory,
};
